export default class PaperError extends Error {
    public readonly name: string;

    public constructor(message = '', name = '') {
        super(message);
        this.name = name;
    }
}
